import { AxiosInstance, AxiosResponse } from 'axios';
import ColisportApiResource from './colisport-api-resource.model';

export default class CreditNoteApi implements ColisportApiResource {
  readonly apiUrlPath = 'creditNote';

  constructor(readonly httpClient: AxiosInstance) {}

  downloadCreditNoteByRefundId(redundId: string): Promise<AxiosResponse<ArrayBuffer>> {
    return this.httpClient.get(`${this.apiUrlPath}/download/refund/${redundId}`, {
      responseType: 'arraybuffer',
    });
  }

  downloadCreditNoteByDownloadId(downloadId: string): Promise<AxiosResponse<ArrayBuffer>> {
    return this.httpClient.get(`${this.apiUrlPath}/download/${downloadId}`, {
      responseType: 'arraybuffer',
    });
  }
}
